<template>
  <div class="col-sm-12 col-lg-10 mx-auto pb-4">
    <h4 class="text-black font-weight-bold">Scegli giorno ed orario</h4>

    <h5 class="text-secondary py-3 font-weight-bold">Questa settimana</h5>
    <div class="py-2 d-flex flex-wrap justify-content-center mx-auto">
      <br />
      <div
        v-for="(data, ind) in this.disponibili"
        :key="ind"
        @click="selectThis(data, ind)"
        :class="data.giorno && dateIfAfter(data.giorno) ? 'col__day' : ''"
      >
        <span
          v-if="data.giorno && dateIfAfter(data.giorno)"
          class="text-white mx-1 py-2 px-3 time__slot point border border-secondary rounded"
          :class="
            selIndex == ind
              ? 'bg-secondary text-white'
              : 'bg-white text-secondary'
          "
          >{{ data.giorno }}</span
        >
      </div>
    </div>
    <br />
    <h5 class="text-secondary py-3 font-weight-bold">La prossima settimana</h5>
    <div class="py-2 d-flex flex-wrap justify-content-center mx-auto">
      <br />
      <div
        v-for="(data, ind) in this.disponibili"
        :key="ind + 6"
        @click="selectThisNext(data, ind)"
        :class="data.giorno && 'col__day'"
      >
        <span
          v-if="data.giorno"
          class="text-white mx-1 py-2 px-3 time__slot point border border-secondary rounded"
          :class="
            selIndex == ind + 6
              ? 'bg-secondary text-white'
              : 'bg-white text-secondary'
          "
          >{{ data.giorno }}</span
        >
      </div>
    </div>
    <br />
    <div
      class="col-7 p-4 justify-content-around d-flex align-items-center menu__div line__bg"
      :style="{ 'background-image': `url(${'/svg/menuline_p.svg'})` }"
    ></div>
    <b-overlay :show="loadingChecks" rounded="sm">
      <div
        v-if="selected"
        class="d-flex flex-wrap div__slot justify-content-center"
      >
        <div
          v-for="(slot, ind) in options"
          :key="ind"
          class="text-white col__slot p-0 d-flex align-content-center"
        >
          <span
            v-if="slot.enabled"
            @click="selectSlot(slot.index)"
            class="py-1 px-2 m-auto point time__slot border border-secondary rounded"
            :class="
              selSlot == slot.index
                ? 'bg-secondary text-white'
                : 'bg-white text-secondary'
            "
            >{{ slot.value }}</span
          >

          <span
            v-else
            class="py-1 px-2 m-auto time__slot rounded"
            :class="slot.class"
            >{{ slot.value }}</span
          >
        </div>
      </div>
    </b-overlay>
    <br />

    <div v-if="selSlot" class="col-9 mx-auto">
      <b-button
        block
        variant="primary rounded-pill font-weight-bold"
        @click="seleziona"
        :disabled="prenotazione == null"
        >Conferma</b-button
      >
    </div>
  </div>
</template>
<script>
import moment from "moment";
// import Spinner from "@/components/Spinner";
export default {
  name: "step-tre",
  props: ["disponibili", "professionista"],
  components: {
    // Spinner
  },
  data() {
    return {
      selected: null,
      selIndex: null,
      selSlot: null,
      intervallo: null,
      prenotazione: null,
      removedList: [],
      loadingChecks: false,
      options: [],
      datesToCheck: [],
    };
  },
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    },
  },
  methods: {
    seleziona() {
      this.$emit("add-date", this.prenotazione);
    },
    selectThis(data, ind) {
      // console.log("selectThis");
      this.selected = data;
      this.selIndex = ind;
      this.selSlot = null;
      this.loadingChecks = true;
      this.removedList.length > 0 && this.resetRemoved();
      this.options = [];
      this.datesToCheck = [];
      this.setOptions();
    },
    selectThisNext(data, ind) {
      // console.log("selectThisNext");
      this.selected = data;
      this.selIndex = ind + 6;
      this.selSlot = null;
      this.loadingChecks = true;
      this.removedList.length > 0 && this.resetRemoved();
      this.options = [];
      this.datesToCheck = [];
      this.setOptions();
    },
    setOptions() {
      for (let slot = 1; slot <= this.selected.slot; slot++) {
        var start = new moment(this.selected.ora_inizio, "LTS");
        var toadd = this.selected.intervallo * slot;
        var slotFinal = moment(start).add(toadd, "m");
        var slotStart = moment(slotFinal).subtract(
          this.selected.intervallo,
          "m"
        );

        var actualDay = moment()
          .day(this.selected.giorno)
          .day();

        if (this.selIndex > 5) {
          actualDay = actualDay + 7;
        }
        var exactDate = moment()
          .day(actualDay)
          .hour(slotStart.hour())
          .minute(slotStart.minutes())
          .seconds(0)
          .format("YYYY-MM-DD HH:mm:ss");

        // console.log("exactDate to check", exactDate);

        var now = moment();
        var option = {
          value: slotStart.format("HH:mm") + "-" + slotFinal.format("HH:mm"),
          index: slot,
          enabled: true,
          class: "bg-disabled-grey",
          data_inizio: exactDate,
        };
        this.options.push(option);
        if (moment(exactDate).isAfter(now)) {
          this.datesToCheck.push(exactDate);
        } else {
          // console.log("moment is before now");
          this.options[slot - 1].enabled = false;
          this.options[slot - 1].class =
            "bg-danger border-danger disabled__click";
        }
      }
      this.checkDates();
    },
    checkDates() {
      var url = process.env.VUE_APP_VERSION + "consulto/check";
      var data = {
        professionista_tipo: this.professionista.tipo,
        professionista_rif: this.professionista.rif,
        data_inizio: this.datesToCheck,
      };
      this.$axios
        .post(url, data)
        .then((res) => {
          // console.log("check date res", res.data.data);
          if (res.data.data.length > 0) {
            this.options.map((opt) => {
              if (res.data.data.includes(opt.data_inizio)) {
                opt.enabled = false;
                opt.class = "bg-danger disabled__click";
              }
            });
          }
          this.loadingChecks = false;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status == 422) {
            this.options.map((opt) => {
              opt.enabled = false;
              opt.class = "bg-danger disabled__click";
            });
            this.loadingChecks = false;
          }
        });
    },
    selectSlot(slot) {
      this.selSlot = slot;
      var start = new moment(this.selected.ora_inizio, "LTS");
      var toadd = this.selected.intervallo * slot;
      var slotFinal = moment(start).add(toadd, "m");
      var slotStart = moment(slotFinal).subtract(this.selected.intervallo, "m");

      var week = moment().week();
      var actualDay = moment()
        .day(this.selected.giorno)
        .day();

      if (this.selIndex > 5) {
        actualDay = actualDay + 7;
        week = week + 1;
      }
      var inizioPrenotazione = moment()
        .day(actualDay)
        .hour(slotStart.hour())
        .minute(slotStart.minutes())
        .seconds(0);

      var finePrenotazione = moment()
        .day(actualDay)
        .hour(slotFinal.hour())
        .minute(slotFinal.minutes())
        .seconds(0);

      // console.log(
      //   "inizioPrenotazione",
      //   inizioPrenotazione.format("YYYY-MM-DD HH:mm:ss")
      // );
      // console.log(
      //   "finePrenotazione",
      //   finePrenotazione.format("YYYY-MM-DD HH:mm:ss")
      // );
      this.prenotazione = {
        data_inizio: inizioPrenotazione.format("YYYY-MM-DD HH:mm:ss"),
        data_fine: finePrenotazione.format("YYYY-MM-DD HH:mm:ss"),
        settimana: week,
      };
    },
    getTime(slot) {
      // console.log("gettime", slot);
      var start = new moment(this.selected.ora_inizio, "LTS");
      var toadd = this.selected.intervallo * slot;
      var slotFinal = moment(start).add(toadd, "m");
      var slotStart = moment(slotFinal).subtract(this.selected.intervallo, "m");

      var actualDay = moment()
        .day(this.selected.giorno)
        .day();

      if (this.selIndex > 5) {
        actualDay = actualDay + 7;
      }
      var exactDate = moment()
        .day(actualDay)
        .hour(slotStart.hour())
        .minute(slotStart.minutes())
        .seconds(0)
        .format("YYYY-MM-DD HH:mm:ss");

      // console.log("exactDate to check", exactDate);
      var now = moment();

      if (moment(exactDate).isAfter(now)) {
        // console.log("moment is after now");

        var url = process.env.VUE_APP_VERSION + "consulto/check";
        var data = {
          professionista_tipo: this.professionista.tipo,
          professionista_rif: this.professionista.rif,
          data_inizio: exactDate,
        };
        this.$axios
          .post(url, data)
          .then((res) => {
            // console.log("check date res");
            if (res.data.data != null) {
              this.removeBooked(slot);
            }
            // if (moment(now).isAfter(exactDate)) {
            //   this.removeBooked(slot);
            //   console.log("moment has passed");
            // }
            if (slot == this.selected.slot) {
              // this.loadingChecks = false;
              // console.log("last call");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      return slotStart.format("HH:mm") + "-" + slotFinal.format("HH:mm");
    },
    dateIfAfter: function(day) {
      var now = moment().day();
      // console.log(now, "day");
      if (now === 0 || now == 6) {
        return false;
      }
      var option = moment()
        .day(day)
        .day();
      if (option < now) {
        return false;
      }
      return true;
    },
    removeBooked(slot) {
      var refName = "slot" + slot;
      var item = this.$refs[refName][0];
      // item.style.display = "none";
      item.className =
        "text-white bg-white mx-1 my-1 py-1 px-2 col-3 disabled__click";
      this.removedList.push(refName);
    },
    resetRemoved() {
      this.removedList.map((el) => {
        var item = this.$refs[el][0];
        if (item) {
          item.className = item._prevClass;
        }
      });
    },
  },
  created() {
    // console.log(this.disponibili);
  },
};
</script>
<style>
.disabled__click {
  pointer-events: none;
}
.opacity__light {
  opacity: 0.4;
}
.time__slot {
  width: 100px;
  height: 35px;
}
.col__slot {
  /* width: 20%; */
  flex: 0 0 25%;
  max-width: 25%;
  position: relative;
  width: 100%;
}
.col__day {
  /* width: 20%; */
  flex: 0 0 20%;
  max-width: 20%;
  position: relative;
  width: 100%;
}
.div__slot div {
  margin-bottom: 0.25rem;
  margin-top: 0.25rem;
}
.div__slot div:last-child {
  margin-right: auto;
  margin-left: 0;
}
</style>
